"use client";

import { c as _c } from "react/compiler-runtime";
import { TCtaCard } from "@shared/types";
import { ButtonLink } from "@shared/ui";
import Image from "next/image";
export function CtaCard(t0) {
  const $ = _c(16);
  const {
    title,
    description,
    button
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      background: "linear-gradient(90deg, #0F8CBA 0%, #0C3245 100%)"
    };
    t2 = <Image src="/images/saridana-cta.webp" alt="CTA ornament" width={350} height={292} className="object-contain bottom-0 right-[20%] absolute object-left-top w-[350px] h-full hidden xl:inline-block" />;
    t3 = <Image src="/images/saridana-cta-md.webp" alt="CTA ornament" width={530} height={444} className="object-contain bottom-0 right-[50px] absolute object-left-top w-[530px] h-full hidden sm:inline-block xl:hidden" />;
    t4 = <Image src="/images/saridana-cta-sm.webp" alt="CTA ornament" width={279} height={234} className="object-contain bottom-[-55px] right-0 absolute object-left-top w-[279px] h-auto inline-block sm:hidden" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = title || "CTA";
  let t6;
  if ($[4] !== t5) {
    t6 = <h3 className="text-[32px] sm:text-4xl font-bold">{t5}</h3>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== description) {
    t7 = description && <p className="mt-4 text-lg sm:text-xl opacity-80">{description}</p>;
    $[6] = description;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <div className="flex-1">{t6}{t7}</div>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== button) {
    t9 = button && <div><ButtonLink className="w-full sm:w-auto" {...button} /></div>;
    $[11] = button;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <div className="relative text-white rounded-2xl px-5 py-9 sm:px-8 sm:py-10 lg:py-12 lg:px-12 overflow-hidden" style={t1}>{t2}{t3}{t4}<div className="relative flex justify-between flex-col sm:flex-row sm:items-center gap-6">{t8}{t9}</div></div>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}